let starsArray = gsap.utils.toArray([ '#star-1', '#star-2', '#star-3' ])
starsArray.forEach((star, i) => {
  star.addEventListener('mouseenter', () => { gsap.to(star, { fill: '#000', y: -5 }) })
  star.addEventListener('mouseleave', () => { gsap.to(star, { fill: '#fff', y: 0, delay: 0.45 }) })
})

let rectanglesArray = gsap.utils.toArray(document.getElementById('rectangles').children)
rectanglesArray.forEach((rectangle, i) => {
    rectangle.addEventListener('mouseenter', () => { gsap.to(rectangle, { y: -5 }) })
    rectangle.addEventListener('mouseleave', () => { gsap.to(rectangle, { y: 0, delay: 0.45 }) })
})

let menuArray = gsap.utils.toArray(document.querySelector('.list-menu--inline').children)
let headerLogo = document.querySelector('.header__heading')
let cartIcon = document.getElementById('cart-icon-bubble')

// if (screen.width > 600) {
  let tl = gsap.timeline({
    id: 'entrance',
    defaults: {
      duration: 1.125,
      ease: "back.out(2.0)",
      stagger: 0.075
    }
  })
  .fromTo(headerLogo, { autoAlpha: 0, y: -50 }, { autoAlpha: 1, delay: 0.0, y: 0 }, 0)
  .fromTo(rectanglesArray, { autoAlpha: 0, y: -50 }, { autoAlpha: 1, y: 0 }, 0)
  .fromTo(starsArray, { autoAlpha: 0, y: -50 }, { autoAlpha: 1, y: 0,  delay: 2.25 }, 0)
  .fromTo(cartIcon, { autoAlpha: 0, y: -50 }, { autoAlpha: 1, y: 0, delay: 2.0 }, 0)
  .fromTo(menuArray, { autoAlpha: 0, y: -50 }, { autoAlpha: 1, y: 0, delay: 0.75, stagger: 0.15 }, 0)
// }

